import { axiosClient } from '@nx-frontend/shared/api';
import { GetNoteTagsPayload } from '@nx-frontend/shared/types';

export const getNoteTags = async ({ workspaceId, noteId }: GetNoteTagsPayload): Promise<string[] | null> => {
  try {
    const { data } = await axiosClient.get<string[]>(`/v2/api/workspaces/${workspaceId}/notes/${noteId}/tags`);
    return data;
  } catch (err) {
    return null;
  }
};
